import { IState } from '../../../store/types';
import { getAudioById } from '../../../store/models/selectors';
import { getCurrentAudioId } from '../../../store/current-video/selectors';
import { TAudioType } from '../../../store/models/types';

// How a lesson line can be played: its media, TTS (text lessons), or not at all (media deleted by saveLevel).
export type TLessonPlayback = 'media' | 'tts' | 'none';

export const getLessonPlayback = (state: IState): TLessonPlayback => {
	const audioId = getCurrentAudioId(state);
	const audio = audioId ? getAudioById(state, audioId) : null;
	if (!audio) return 'none';
	if (audio.type === TAudioType.TEXT) return 'tts';
	return audio.url || audio.videoUrl ? 'media' : 'none';
};
